import React, { useState, type KeyboardEvent } from 'react';
import { Popover } from '@one-thd/sui-atomic-components';

const HELP_TEXT_ID = 'restart-verification-help';

function RestartText() {
  return (
    <p id={HELP_TEXT_ID}>
      There are a few reasons why you may need to restart your verification: the
      verification failed, expired, or there was an error in your application
      information. If you encounter any of these cases, you will need to restart
      the verification process.
    </p>
  );
}

export default function RestartTooltip() {
  const [anchorEl, setAnchorEl] = useState<HTMLImageElement | null>(null);
  const [open, setOpen] = useState(false);

  const close = () => setOpen(false);
  const show = () => setOpen(true);

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      close();
    }
  };

  return (
    <>
      <img
        ref={setAnchorEl}
        src="https://assets.thdstatic.com/images/v1/info.svg"
        alt="info icon"
        tabIndex={0}
        aria-describedby={HELP_TEXT_ID}
        onMouseOver={show}
        onMouseOut={close}
        onFocus={show}
        onBlur={close}
        onKeyDown={handleKeyDown}
      />
      <Popover
        open={open}
        anchorEl={anchorEl}
        placement="top"
        offset="loose"
        disableEnforceFocus
        onClose={close}
      >
        <RestartText />
      </Popover>
    </>
  );
}
